import { RedemptionLogRptConstants } from "../constants";

export function RedemptionLogRpt(state = {}, action) {
    switch (action.type) {
        case RedemptionLogRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case RedemptionLogRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case RedemptionLogRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case RedemptionLogRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case RedemptionLogRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case RedemptionLogRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case RedemptionLogRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}